import PropTypes from 'prop-types';
import React from 'react';
import Popup from 'reactjs-popup';
import '../styles/mobileFullCalendar.css';

const YEAR_RANGE_BEFORE = 2;
const YEAR_RANGE_AFTER = 3;

export const buildYearOptions = (currentYear) => {
  const years = [];
  for (let y = currentYear - YEAR_RANGE_BEFORE; y <= currentYear + YEAR_RANGE_AFTER; y++) {
    years.push({ value: y, label: String(y) });
  }
  return years;
};

const baseContentStyle = {
  border: 'none',
  borderRadius: '8px',
  boxShadow: '0 0 1px 1px rgba(0,0,0,0.04), 0 8px 16px 0 rgba(0,0,0,0.12)',
  padding: '6px 0',
  background: 'var(--od-surface, #fff)',
  width: '160px',
  marginTop: '4px',
  zIndex: 3000
};

const DropdownTrigger = React.forwardRef(({ label, ariaLabel, onClick }, ref) => (
  <button
    ref={ref}
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    className="mobile-calendar-dropdown-trigger"
  >
    {label}
    <svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 7.5L10 12.5L15 7.5" style={{ stroke: 'var(--od-c-414651, #414651)' }} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </button>
));

DropdownTrigger.displayName = 'DropdownTrigger';

DropdownTrigger.propTypes = {
  label: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func
};

const DropdownMenu = ({ options, selectedValue, onSelect, close }) => (
  <div role="menu" className="mobile-calendar-dropdown-menu">
    {options.map(({ value, label }) => {
      const isSelected = value === selectedValue;
      const itemClass = `mobile-calendar-dropdown-item${isSelected ? ' mobile-calendar-dropdown-item--selected' : ''}`;
      return (
        <button
          key={value}
          role="menuitem"
          type="button"
          onClick={() => {
            onSelect(value);
            close();
          }}
          className={itemClass}
        >
          <span>{label}</span>
          {isSelected && (
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.6667 5L7.5 14.1667L3.33333 10" stroke="#2563EB" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </button>
      );
    })}
  </div>
);

DropdownMenu.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.node.isRequired
  })).isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelect: PropTypes.func.isRequired,
  close: PropTypes.func
};

const MobileCalendarDropdown = ({
  label,
  ariaLabel,
  options,
  selectedValue,
  onSelect,
  width
}) => (
  <Popup
    arrow={false}
    position="bottom center"
    contentStyle={width ? { ...baseContentStyle, width } : baseContentStyle}
    overlayStyle={{ zIndex: 2999 }}
    trigger={<DropdownTrigger label={label} ariaLabel={ariaLabel} />}
  >
    {close => (
      <DropdownMenu
        options={options}
        selectedValue={selectedValue}
        onSelect={onSelect}
        close={close}
      />
    )}
  </Popup>
);

MobileCalendarDropdown.propTypes = {
  label: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
  options: PropTypes.array.isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelect: PropTypes.func.isRequired,
  width: PropTypes.string
};

export default MobileCalendarDropdown;
